<template>
  <AppModalEdit
    v-model="isActive"
    title="代理店マージン編集"
    execButtonText="変更申請"
    @clickExec="saveEditedItem"
  >
    <v-container grid-list-md>
      <v-layout wrap>
        <v-flex xs2>
          <h4>名称</h4>
        </v-flex>
        <v-flex xs10>
          {{ item.name }}
        </v-flex>
        <v-flex xs2>
          <h4>マージン率</h4>
        </v-flex>
        <v-flex xs10>
          {{ item.marginPercent }}
        </v-flex>
      </v-layout>
      <date-range-picker
        :defaultUseDateRange="this.item.useDateRange"
        :start="startDate"
        :end="endDate"
        label="使用可能期間"
        uselabel="期間を指定する"
        notUselabel="期間を指定しない"
        @change="changeDateRange"
      />
    </v-container>
  </AppModalEdit>
</template>

<script>
import DateRangePicker from '@/components/Shared/CrudUI/DateRangePicker'
export default {
  components: { DateRangePicker },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      startDate: '',
      endDate: '',
    }
  },
  watch: {
    value(val) {
      if (!val) return
      this.startDate = this.item.startDate
      this.endDate = this.item.endDate
    },
  },
  computed: {
    isActive: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    async saveEditedItem() {
      console.log('save')
      console.log(this.item)
      // await this.item.createRequest()
    },
    changeDateRange(obj) {
      this.startDate = obj.startDate
      this.endDate = obj.endDate
    },
  },
}
</script>
